import { useEffect } from 'react';

import Pagination from '@mui/material/Pagination';
import { CustomPaginationProps } from 'types';
import {
  PAGINATION_BOUNDARY_COUNT,
  PAGINATION_SIBLING_COUNT
} from '@constants/pagination';

import theme from '../../../themes/colors';

const CustomPagination = ({
  totalCount,
  limit,
  page,
  setPage
}: CustomPaginationProps) => {
  const pageCount = Math.ceil(totalCount / limit);

  const handlePageChange = (event: any, value: number) => {
    setPage(value);
  };

  useEffect(() => {
    document
      .getElementById('main-layout-wrapper')
      ?.scrollTo({ top: 0, behavior: 'smooth' });
  }, [page]);

  useEffect(() => {
    if (limit === totalCount) {
      setPage(1);
    }
  }, [limit, setPage, totalCount]);

  return (
    <Pagination
      color="standard"
      shape="rounded"
      className="text-grey"
      sx={{
        '& .MuiPaginationItem-root.Mui-selected': {
          backgroundColor: theme.primary,
          color: theme.theme
        },
        '& .MuiPaginationItem-root': {
          backgroundColor: theme.theme,
          color: theme.content
        }
      }}
      count={pageCount}
      page={page}
      onChange={handlePageChange}
      siblingCount={PAGINATION_SIBLING_COUNT}
      boundaryCount={PAGINATION_BOUNDARY_COUNT}
    />
  );
};

export default CustomPagination;
